import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REWARD_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

export const fetchGRNStatusList = createAsyncThunk("fetchGRNStatusList", async ({ channelId }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`${REWARD_BASE_URL}channel/${channelId}/grn-status`);
		return response.data;
	} catch (err) {
		if (!err.response) throw err;
		return rejectWithValue(err.response.data);
	}
});

const RewardsGRNStatusListSlice = createSlice({
	name: "RewardsGRNStatusListSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetGRNStatusListState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchGRNStatusList.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchGRNStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(fetchGRNStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetGRNStatusListState } = RewardsGRNStatusListSlice.actions;
export default RewardsGRNStatusListSlice.reducer;
